import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spaces',
  templateUrl: './spaces.component.html'
})
export class SpacesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
